export const WR_USERS_WAITING_REQUEST = "WR_USERS_WAITING_REQUEST";
export const WR_USERS_WAITING_SUCCESS = "WR_USERS_WAITING_SUCCESS";
export const WR_USERS_WAITING_FAIL = "WR_USERS_WAITING_FAIL";
export const WR_USERS_WAITING_RESET = "WR_USERS_WAITING_RESET";
